module.exports = __webpack_public_path__ + "img/23_50.3f44a75d.png";